import React, { useRef, useState } from 'react';
import axios from 'axios';
import { Form, Input, Button, Table } from 'antd';
import { toast } from 'react-toastify';
import ReactToPrint from 'react-to-print';

import { ComponentToPrint } from './Print';

toast.configure();

const Refund = () => {
    const [dados, setDados] = useState({ nrcliente: '', nome: '', bi: '', nuit: '', morada: '', email: '', telemovel: '' });
    const [apanhado, setApanhado] = useState(null);
    const [error, setError] = useState(null);
    const [tokens, setTokens] = useState(null);
    const [tokenss, setTokenss] = useState(null);
    const [Refundme, setRefunme] = useState(null);
    const RefundTask = useRef();

    const Pesquisar = () => {
        axios({
            method: "GET",
            url: `${localStorage.getItem('url')}/web/contador/`,
            headers: { 'Authorization': `token ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
            params: { contador: dados.nrcliente }
        }).then(dat => {
            if (dat.status !== 200) {
                throw Error('Dados de acesso invalidos');
            }
            return dat;
        }).then(d => {
            setDados({ ...dados, nrscliente: d.data.idCliente, nome: d.data.nome, nuit: d.data.nuit, bi: d.data.bi, email: d.data.email, morada: d.data.morada, telemovel: d.data.telemovel });
            setApanhado("sds");
            Tokens_recargas();
        }).catch(e => {
            setError(e.message);
            toast.error('Cliente nao encontrado!');
        });
    };

    const Handler = (e) => {
        e.preventDefault();
        Pesquisar();
    };

    const Tokens_recargas = () => {
        axios({
            method: "post",
            url: `${localStorage.getItem('url')}/web/TokensRecarga`,
            headers: { 'Authorization': `token ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
            data: { id: '10118' }
        }).then(dat => {
            if (dat.status !== 200) {
                throw Error('Dados de acesso invalidos');
            }
            setTokens(dat.data);
            setTokenss(dat.data);
        }).catch(e => {
            setError(e.message);
        });
    };

    const RefundM = () => {
        axios({
            method: "post",
            url: `${localStorage.getItem('url')}/web/RefundCliente/`,
            headers: { 'Authorization': `token ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
            data: {
                id: dados.nrcliente,
                meter: Ultimo(tokens)[0].idContador,
                datas: Ultimo(tokens)[0].data_de_compra
            }
        }).then(dat => {
            if (dat.status !== 200) {
                throw Error('Dados de acesso invalidos');
            }
            toast.success('Refund Sucesso!');
            setTokens(null);
            setRefunme('sdsd');
        }).catch(e => {
            setError(e.message);
        });
    };

    const Ultimo = (row) => {
        const l = row.length - 1;
        const data = [];
        let ss = new Date(row[l].data_de_compra);
        let fim = new Date();
        let inicio = new Date();
        inicio.setDate(fim.getDate() - 7);
        if (parseFloat(ss.getTime()) > parseFloat(inicio.getTime()) && parseFloat(ss.getTime()) < parseFloat(fim.getTime())) {
            row = row[l];
            data.push(row);
            return data;
        } else {
            data.push({
                data_de_compra: null,
                id: null,
                idCliente: null,
                idContador: null,
                idToken: null,
                iva: null,
                mes: null,
                metodo: null,
                metroscubicos: null,
                numero_contador: null,
                numero_token: null,
                tsc: null,
                valor_pago: null
            });
            return data;
        }
    };

    const REfundHandler = (e) => {
        e.preventDefault();
        RefundM();
    };

    const columns = [
        { title: 'Nome', dataIndex: 'nome', key: 'nome' },
        { title: 'Numero de Contador', dataIndex: 'numero_contador', key: 'numero_contador' },
        { title: 'Token', dataIndex: 'numero_token', key: 'numero_token' },
        { title: 'Valor Pago', dataIndex: 'valor_pago', key: 'valor_pago' },
        { title: 'Metros cubicos', dataIndex: 'metroscubicos', key: 'metroscubicos' },
        { title: 'Iva', dataIndex: 'iva', key: 'iva' },
        { title: 'TSC', dataIndex: 'tsc', key: 'tsc' },
        { title: 'Data de Geracao', dataIndex: 'data_de_compra', key: 'data_de_compra' },
        { title: 'Metodo de Pagamento', dataIndex: 'metodo', key: 'metodo' },
        { title: 'Plataforma', dataIndex: 'plataforma', key: 'plataforma', render: () => 'Web' }
    ];

    return (
        <div>
            <div  >
                <label>
                    <span>Numero do Contador</span>
                </label>
                <Input  autoComplete='off' onChange={e => setDados({ ...dados, nrcliente: e.target.value })} value={dados.nrcliente} suffix={<Button type="primary" id="pesqui" onClick={Handler}>Pesquisar</Button>} required />
                
            </div>
            {apanhado && (
                <div className='informacoes'>
                    {/* Your existing information div goes here */}
                </div>
            )}
            {tokens && (
                <div className='subinfo'>
                    <Table dataSource={Ultimo(tokens)} columns={columns} />
                    <Button className="pesquisa" onClick={REfundHandler}>Refund</Button>
                </div>
            )}
            {Refundme && (
                <div>
                    {/* Your existing refund information div goes here */}
                </div>
            )}
            <ComponentToPrint ref={RefundTask}>
                <div className="relatorio">
                    {/* Your existing component to print goes here */}
                </div>
            </ComponentToPrint>
        </div>
    );
};

export default Refund;
